import { Injectable } from '@angular/core';
import { UntypedFormArray, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { ChildrenFormObject } from '@app/forms/subscription/definition/interface/subscription';
import * as _ from 'lodash';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: ChildrenFormObject) {
    const form = this.formBuilder.group({
      ownerId: [entity.ownerId],
      child: this.formBuilder.group({
        id: [entity?.child?.id || null],
        civility: [entity?.child?.civility || null, Validators.required],
        lastName: [entity?.child?.lastName || null, Validators.required],
        firstName: [entity?.child?.firstName || null, Validators.required],
        birthDate: [entity?.child?.birthDate || null, Validators.required],
        birthCountry: [
          entity?.child?.birthCountry || null,
          Validators.required,
        ],
        birthZipCode: [
          entity?.child?.birthZipCode || null,
          Validators.required,
        ],
        birthLocation: [
          entity?.child?.birthLocation || null,
          Validators.required,
        ],
        birthCity: [entity?.child?.birthCity || null, Validators.required],
        nationality: [entity?.child?.nationality || null, Validators.required],
        legalCapacity: [
          entity?.child?.legalCapacity || null,
          Validators.required,
        ],
        antiMoneyLaundering: this.formBuilder.group({
          id: [entity?.child?.antiMoneyLaundering?.id || null],
          accountId: [entity?.child?.antiMoneyLaundering?.accountId || null],
          ownerId: [
            entity?.child?.antiMoneyLaundering?.ownerId || entity?.child?.id,
          ],
          beneficialOwnerId: [
            entity?.child?.antiMoneyLaundering?.beneficialOwnerId || null,
          ],
          profile: [entity?.child?.antiMoneyLaundering?.profile || 'PHYSICAL'],
          ppe: [
            _.isNil(entity?.child?.antiMoneyLaundering?.ppe)
              ? false
              : entity?.child?.antiMoneyLaundering?.ppe,
          ],
          adresseDomiciliation: [
            _.isNil(entity?.child?.antiMoneyLaundering?.adresseDomiciliation)
              ? false
              : entity?.child?.antiMoneyLaundering?.adresseDomiciliation,
          ],
          fortuneInfluent: [
            _.isNil(entity?.child?.antiMoneyLaundering?.fortuneInfluent)
              ? false
              : entity?.child?.antiMoneyLaundering?.fortuneInfluent,
          ],
          secteurRisqueCorruption: [
            _.isNil(entity?.child?.antiMoneyLaundering?.secteurRisqueCorruption)
              ? false
              : entity?.child?.antiMoneyLaundering?.secteurRisqueCorruption,
          ],
          discretionInhabituelle: [
            _.isNil(entity?.child?.antiMoneyLaundering?.discretionInhabituelle)
              ? false
              : entity?.child?.antiMoneyLaundering?.discretionInhabituelle,
          ],
          operationPaysGafi: [
            _.isNil(entity?.child?.antiMoneyLaundering?.operationPaysGafi)
              ? false
              : entity?.child?.antiMoneyLaundering?.operationPaysGafi,
          ],
          fondPaysGafi: [
            _.isNil(entity?.child?.antiMoneyLaundering?.fondPaysGafi)
              ? false
              : entity?.child?.antiMoneyLaundering?.fondPaysGafi,
          ],
          operationPaysNonCooperatif: [
            _.isNil(
              entity?.child?.antiMoneyLaundering?.operationPaysNonCooperatif,
            )
              ? false
              : entity?.child?.antiMoneyLaundering?.operationPaysNonCooperatif,
          ],
          fondPaysNonCooperatif: [
            _.isNil(entity?.child?.antiMoneyLaundering?.fondPaysNonCooperatif)
              ? false
              : entity?.child?.antiMoneyLaundering?.fondPaysNonCooperatif,
          ],
          personneListeGelsDesAvoirs: [
            _.isNil(
              entity?.child?.antiMoneyLaundering?.personneListeGelsDesAvoirs,
            )
              ? false
              : entity?.child?.antiMoneyLaundering?.personneListeGelsDesAvoirs,
          ],
          fondListeGelsDesAvoirs: [
            _.isNil(entity?.child?.antiMoneyLaundering?.fondListeGelsDesAvoirs)
              ? false
              : entity?.child?.antiMoneyLaundering?.fondListeGelsDesAvoirs,
          ],
          versementPeePerco: [
            _.isNil(entity?.child?.antiMoneyLaundering?.versementPeePerco)
              ? false
              : entity?.child?.antiMoneyLaundering?.versementPeePerco,
          ],
          produitsAtypiques: [
            _.isNil(entity?.child?.antiMoneyLaundering?.produitsAtypiques)
              ? false
              : entity?.child?.antiMoneyLaundering?.produitsAtypiques,
          ],
          controleActifsFonds: [
            _.isNil(entity?.child?.antiMoneyLaundering?.controleActifsFonds)
              ? false
              : entity?.child?.antiMoneyLaundering?.controleActifsFonds,
          ],
          compteTitreAugmentationCapital: [
            _.isNil(
              entity?.child?.antiMoneyLaundering
                ?.compteTitreAugmentationCapital,
            )
              ? false
              : entity?.child?.antiMoneyLaundering
                  ?.compteTitreAugmentationCapital,
          ],
          primeAnnuelleUnique: [
            _.isNil(entity?.child?.antiMoneyLaundering?.primeAnnuelleUnique)
              ? false
              : entity?.child?.antiMoneyLaundering?.primeAnnuelleUnique,
          ],
          contratPrevoyanceSante: [
            _.isNil(entity?.child?.antiMoneyLaundering?.contratPrevoyanceSante)
              ? false
              : entity?.child?.antiMoneyLaundering?.contratPrevoyanceSante,
          ],
          assuranceEmprunteur: [
            _.isNil(entity?.child?.antiMoneyLaundering?.assuranceEmprunteur)
              ? false
              : entity?.child?.antiMoneyLaundering?.assuranceEmprunteur,
          ],
          contratAssuranceSansClauseRachat: [
            _.isNil(
              entity?.child?.antiMoneyLaundering
                ?.contratAssuranceSansClauseRachat,
            )
              ? false
              : entity?.child?.antiMoneyLaundering
                  ?.contratAssuranceSansClauseRachat,
          ],
          contratAnonyme: [
            _.isNil(entity?.child?.antiMoneyLaundering?.contratAnonyme)
              ? false
              : entity?.child?.antiMoneyLaundering?.contratAnonyme,
          ],
          produitsImmobiliersLuxe: [
            _.isNil(entity?.child?.antiMoneyLaundering?.produitsImmobiliersLuxe)
              ? false
              : entity?.child?.antiMoneyLaundering?.produitsImmobiliersLuxe,
          ],
        }),
      }),
    });

    return form;
  }
  generate(entity: any, option) {
    const ownerWithChild = entity?.owners.find(owner => owner.child);
    return FormGroupArray.generate({
      ownerId: ownerWithChild?.ownerId || undefined,
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }

  extract() {
    return this.form.value.owners;
  }

  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
}
